// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IInvestorAccountResponse } from './IInvestorAccountResponse';
import {
    IInvestorAccountResponseFromJSON,
    IInvestorAccountResponseFromJSONTyped,
    IInvestorAccountResponseToJSON,
    IInvestorAccountResponseToJSONTyped,
} from './IInvestorAccountResponse';
import type { IHsaAccountResponse } from './IHsaAccountResponse';
import {
    IHsaAccountResponseFromJSON,
    IHsaAccountResponseFromJSONTyped,
    IHsaAccountResponseToJSON,
    IHsaAccountResponseToJSONTyped,
} from './IHsaAccountResponse';

/**
 * 
 * @export
 * @interface ICombineHsaSearchResponse
 */
export interface ICombineHsaSearchResponse {
    /**
     * 
     * @type {number}
     * @memberof ICombineHsaSearchResponse
     */
    employee_id: number;
    /**
     * 
     * @type {string}
     * @memberof ICombineHsaSearchResponse
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ICombineHsaSearchResponse
     */
    last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ICombineHsaSearchResponse
     */
    ssn?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ICombineHsaSearchResponse
     */
    birth_on?: Date;
    /**
     * 
     * @type {string}
     * @memberof ICombineHsaSearchResponse
     */
    employer_name?: string;
    /**
     * 
     * @type {string}
     * @memberof ICombineHsaSearchResponse
     */
    partner_name?: string;
    /**
     * 
     * @type {IHsaAccountResponse}
     * @memberof ICombineHsaSearchResponse
     */
    account?: IHsaAccountResponse | null;
    /**
     * 
     * @type {IInvestorAccountResponse}
     * @memberof ICombineHsaSearchResponse
     */
    investor_account?: IInvestorAccountResponse;
}

/**
 * Check if a given object implements the ICombineHsaSearchResponse interface.
 */
export function instanceOfICombineHsaSearchResponse(value: object): value is ICombineHsaSearchResponse {
    if (!('employee_id' in value) || value['employee_id'] === undefined) return false;
    return true;
}

export function ICombineHsaSearchResponseFromJSON(json: any): ICombineHsaSearchResponse {
    return ICombineHsaSearchResponseFromJSONTyped(json, false);
}

export function ICombineHsaSearchResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ICombineHsaSearchResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'employee_id': json['employee_id'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'ssn': json['ssn'] == null ? undefined : json['ssn'],
        'birth_on': json['birth_on'] == null ? undefined : (new Date(json['birth_on'])),
        'employer_name': json['employer_name'] == null ? undefined : json['employer_name'],
        'partner_name': json['partner_name'] == null ? undefined : json['partner_name'],
        'account': json['account'] == null ? undefined : IHsaAccountResponseFromJSON(json['account']),
        'investor_account': json['investor_account'] == null ? undefined : IInvestorAccountResponseFromJSON(json['investor_account']),
    };
}

export function ICombineHsaSearchResponseToJSON(json: any): ICombineHsaSearchResponse {
    return ICombineHsaSearchResponseToJSONTyped(json, false);
}

export function ICombineHsaSearchResponseToJSONTyped(value?: ICombineHsaSearchResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'employee_id': value['employee_id'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'ssn': value['ssn'],
        'birth_on': value['birth_on'] == null ? undefined : ((value['birth_on']).toISOString().substring(0,10)),
        'employer_name': value['employer_name'],
        'partner_name': value['partner_name'],
        'account': IHsaAccountResponseToJSON(value['account']),
        'investor_account': IInvestorAccountResponseToJSON(value['investor_account']),
    };
}

